import { useCallback } from 'react';

import { LinkOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { useParams } from 'react-router';

import { useSendSchoolParticipantsInvitesMutation } from '@/api/endpoints/schools/schoolParticipants';
import { ConfirmModal } from '@/shared/components';
import { ENVS, ROUTES } from '@/shared/consts';
import { useApiRequest } from '@/shared/hooks';

import styles from './SendInvitesModal.module.scss';

interface IProp {
  isModalOpen: boolean;
  handleCancel: VoidFunction;
}

export const SendInvitesModal = ({ isModalOpen, handleCancel }: IProp) => {
  const [sendInvites, { isLoading: areInvitesSending }] = useSendSchoolParticipantsInvitesMutation();

  const { id: schoolId } = useParams();

  const sendApiRequest = useApiRequest();

  const handleOk = useCallback(
    () =>
      sendApiRequest({
        apiRequestCallback: () =>
          sendInvites({
            schoolId: Number(schoolId),
            invitationLink: `${ENVS.SSO_SITE_URL}/${ROUTES.PASSWORD_RECOVERY}`,
          }),
        successMessage: 'Приглашения успешно отправлены',
        successCallback: handleCancel,
      }),
    [schoolId, sendInvites],
  );

  return (
    <ConfirmModal
      isModalOpen={isModalOpen}
      handleCancel={handleCancel}
      handleConfirm={handleOk}
      title="Отправить приглашения"
      confirmButtonText="Отправить"
      shouldDisableElement={areInvitesSending}
    >
      <div className={styles.wrapper}>
        <p className={styles.description}>
          Вы уверены, что хотите отправить приглашения всем сотрудникам из списка для школы?
        </p>
        <div className={styles['link-wrapper']}>
          <p className={styles['link-title']}>Ссылка для приглашения:</p>
          <Typography.Text
            className={styles.link}
            copyable={{
              icon: [<LinkOutlined key={1} />],
              tooltips: ['Копировать', 'Скопировано'],
            }}
          >{`${ENVS.SSO_SITE_URL}/${ROUTES.PASSWORD_RECOVERY}`}</Typography.Text>
        </div>
        <p className={styles.description}>
          После подтверждения, письма с этой ссылкой будут автоматически отправлены всем сотрудникам.
        </p>
      </div>
    </ConfirmModal>
  );
};
